import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API_URL = '';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { updateUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.slice(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          throw new Error('No session ID found');
        }

        // Exchange session_id for session_token
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          throw new Error('Authentication failed');
        }

        const data = await response.json();
        // ─── Admin branch: backend asked for TOTP step-up before issuing session
        if (data && data.requires_2fa && data.pre_session_id) {
          const params = new URLSearchParams({
            pre_session_id: data.pre_session_id,
            setup: data.tfa_setup_required ? '1' : '0',
            email: data.email_masked || '',
          });
          navigate(`/verify-totp?${params.toString()}`, { replace: true });
          return;
        }

        const user = data;
        updateUser(user);

        // Navigate to dashboard/home
        navigate('/', { state: { user }, replace: true });
      } catch (err) {
        console.error('Auth callback error:', err);
        setError(err.message);
        setTimeout(() => navigate('/'), 3000);
      }
    };

    processAuth();
  }, [navigate, updateUser]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#FCFBF9] flex items-center justify-center">
        <div className="text-center">
          <p className="text-[#C87979] mb-4">Erreur d'authentification: {error}</p>
          <p className="text-[#6B6A68]">Redirection en cours...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FCFBF9] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 size={40} className="animate-spin text-[#D4AF37] mx-auto mb-4" />
        <p className="text-[#6B6A68]">Connexion en cours...</p>
      </div>
    </div>
  );
}
